import React from 'react';
import { connect } from 'react-redux';
import moment from "moment/moment";
import Chart from 'chart.js'
import numeral from "numeral";
import map from "lodash/map";

import { fetchStatsIfNeeded, refreshStats } from "../../../../../actions/app/mpt/stats";
import selectEntities from "../../../../../selectors/entities";
import Loader from "../../../../../components/Loader";
import DateRangePickerWrapper from "../../../../../components/DatePicker/DateRangePickerWrapper";

import './MptUsersStatsWidget.css'

let chart;

class MptUsersStatsWidget extends React.Component {
    constructor(props) {
        super(props);

        // We set the date to yesterday and we subtract 30 days
        const today = new Date();
        const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
        const start = moment(today.setDate(today.getDate() - 30 )).format('YYYY-MM-DD');

        this.state = { end, start }
    }

    fetchStats() {
        const { end, start } = this.state;
        this.props.dispatch(fetchStatsIfNeeded({ end, start }));
    }

    refreshStats() {
        const { end, start } = this.state;
        this.props.dispatch(refreshStats({ end, start }));
    }

    componentDidMount() {
        this.fetchStats();

        const ctx = document.getElementById('newMembersMPTChart');
        if (ctx)
            chart = new Chart(ctx, {
                type: 'bar',
                data: { datasets: [] },
                options: {
                    scales: {
                        xAxes: [{
                            id: 'date',
                            type: 'time',
                            stacked: true
                        }],
                        yAxes: [{
                            id: 'members',
                            type: 'linear',
                            stacked: true
                        }]
                    }
                }
            });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.widget.ids !== this.props.widget.ids) {
            const { entities } = nextProps.statistics;

            const datasets = [{
                label: 'MPG',
                backgroundColor: '#ed9728',
                xAxisID: 'date',
                yAxisID: 'members',
                data: []
            },{
                label: 'MPP',
                backgroundColor: '#9fc99e',
                xAxisID: 'date',
                yAxisID: 'members',
                data: []
            }, {
                label: 'Predict',
                backgroundColor: '#819bb7',
                xAxisID: 'date',
                yAxisID: 'members',
                data: []
            }, {
                label: 'Quiniela',
                backgroundColor: '#dd9189',
                xAxisID: 'date',
                yAxisID: 'members',
                data: []
            }, {
                label: 'MPT',
                backgroundColor: '#aae750',
                xAxisID: 'date',
                yAxisID: 'members',
                data: []
            }, ];

            map(entities, stat => {
                datasets[0].data.push({ x: moment(stat.date).format('LL'), y: parseInt(stat.mpg, 10) });
                datasets[1].data.push({ x: moment(stat.date).format('LL'), y: parseInt(stat.mpp, 10) });
                datasets[2].data.push({ x: moment(stat.date).format('LL'), y: parseInt(stat.mppEn, 10) });
                datasets[3].data.push({ x: moment(stat.date).format('LL'), y: parseInt(stat.mppEs, 10) });
                datasets[4].data.push({ x: moment(stat.date).format('LL'), y: parseInt(stat.mpt, 10) });
            });

            chart.data.datasets = datasets;
            chart.update();
        }
    }

    render() {
        const { end, start } = this.state;
        const { info } = this.props.widget;
        let { entities, total } = this.props.statistics;

        let sum = { mpg:0,mpp: 0, mppEn:0,mppEs:0,mpt:0 };
        // eslint-disable-next-line
        const increasingCumulativeAMount = entities.map(stat => {
            sum.mpp += stat.mpp || 0;
            sum.mppEn += stat.mppEn || 0;
            sum.mppEs += stat.mppEs || 0;
            sum.mpg += stat.mpg || 0;
            sum.mpt += stat.mpt || 0;

            return { data: stat.data, amount: sum };
        });
        return (
            <div id="MptUsersStatsWidget">
                <div className="box box-default">
                    <div className="box-header with-border">
                        <h3 className="box-title pull-left">
                            <i className="fa fa-address-card-o"/> Registrations / New members
                        </h3>
                    </div>
                    <div className="box-body">
                        <div className="text-center margin-bottom">
                            Users from
                            <div className="inline data-range-picker">
                                <DateRangePickerWrapper
                                    initialStartDate={moment(start)}
                                    initialEndDate={moment(end)}
                                    isOutsideRange={day => {
                                        return moment(day).startOf('day').unix() > moment().startOf('day').unix()
                                    }}
                                    onDatesChange={({ startDate, endDate }) => {
                                        this.setState({
                                            start: moment(startDate).format('YYYY-MM-DD'),
                                            end: moment(endDate).format('YYYY-MM-DD')
                                        });
                                    }}
                                />
                                <button
                                    className="btn btn-default"
                                    onClick={() => this.refreshStats()}
                                >
                                    <i className="fa fa-refresh"/>
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="chart">
                                    <canvas id="newMembersMPTChart"/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="table-responsive table-fixed-height">
                                    <table className="table table-bordered no-margin">
                                        <thead>
                                        <tr>
                                            <th>Day</th>
                                            <th className="text-center">MPG</th>
                                            <th className="text-center">MPP</th>
                                            <th className="text-center">Predict</th>
                                            <th className="text-center">Quiniela</th>
                                            <th className="text-center">MPT</th>
                                            <th className="text-center">Total</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        { entities.map((stat, key) => (
                                            <tr key={key} className="text-center">
                                                <td className="text-left">{moment(stat.date).format('LL')}</td>
                                                <td>{stat.mpg}</td>
                                                <td>{stat.mpp}</td>
                                                <td>{stat.mppEn}</td>
                                                <td>{stat.mppEs}</td>
                                                <td>{stat.mpt}</td>
                                                <td>
                                                    { numeral(
                                                        + parseInt(stat.mpp, 10)
                                                        + parseInt(stat.mppEn, 10)
                                                        + parseInt(stat.mppEs, 10)
                                                        + parseInt(stat.mpg, 10)
                                                        + parseInt(stat.mpt, 10)
                                                    ).format('0,0') }
                                                </td>
                                            </tr>
                                        ))}
                                        { entities.length > 0 && (
                                            <tr key="all" className="text-center">
                                                <td className="text-left">
                                                    Sum from {moment(start).format("LL")} to
                                                    &nbsp;{moment(end).format("LL")}
                                                </td>
                                                <td>{sum.mpg}</td>
                                                <td>{sum.mpp}</td>
                                                <td>{sum.mppEn}</td>
                                                <td>{sum.mppEs}</td>
                                                <td>{sum.mpt}</td>
                                                <td>
                                                    { numeral(
                                                        + parseInt(sum.mpp, 10)
                                                        + parseInt(sum.mppEn, 10)
                                                        + parseInt(sum.mppEs, 10)
                                                        + parseInt(sum.mpg, 10)
                                                        + parseInt(sum.mpt, 10)
                                                    ).format('0,0') }
                                                </td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {
                            total && (
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-xs-6 col-md-3">
                                            <div className="description-block">
                                                <h5 className="description-header">
                                                    { numeral(total.mpg, 10).format('0,0') }
                                                </h5>
                                                <span className="description-text text-mppEs">MPG</span>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 col-md-3">
                                            <div className="description-block">
                                                <h5 className="description-header">
                                                    { numeral(total.mpp, 10).format('0,0') }
                                                </h5>
                                                <span className="description-text text-mpp">MonPetitProno</span>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 col-md-3">
                                            <div className="description-block">
                                                <h5 className="description-header">
                                                    { numeral(total.mppEn, 10).format('0,0') }
                                                </h5>
                                                <span className="description-text text-mppEn">Predict MPG</span>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 col-md-3">
                                            <div className="description-block">
                                                <h5 className="description-header">
                                                    { numeral(total.mppEs, 10).format('0,0') }
                                                </h5>
                                                <span className="description-text text-mppEs">Quiniela MPG</span>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 col-md-3">
                                            <div className="description-block">
                                                <h5 className="description-header">
                                                    { numeral(total.mpt, 10).format('0,0') }
                                                </h5>
                                                <span className="description-text text-mpt">MPT</span>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 col-md-3">
                                            <div className="description-block border-right">
                                                <h5 className="description-header">
                                                    { numeral(
                                                        + parseInt(total.mpp, 10)
                                                        + parseInt(total.mppEn, 10)
                                                        + parseInt(total.mppEs, 10)
                                                        + parseInt(total.mpg, 10)
                                                        + parseInt(total.mpt, 10)
                                                    ).format('0,0') }
                                                </h5>
                                                <span className="description-text">Total</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {info.isFetching && <Loader/>}
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => {
        const { statistics } = state.entities;
        const { userStats } = state.app.mpt;

        return {
            widget: userStats,
            statistics: { entities: selectEntities(statistics, userStats.ids), total: userStats.total }
        };
    },
    dispatch => ({ dispatch }),
)(MptUsersStatsWidget);



// WEBPACK FOOTER //
// ./src/pages/MPT/Stats/Widgets/Users/index.js